import { defineAsyncComponent } from "vue";

export const LabelSizes = defineAsyncComponent(() =>
  import("@/components/Modals/Labels/LabelSizes.vue" /* webpackChunkName: "labelSizes" */)
);
export const LabelShapes = defineAsyncComponent(() =>
  import("@/components/Modals/Labels/LabelShapes.vue" /* webpackChunkName: "labelShapes" */)
);
export const LabelMaterials = defineAsyncComponent(() =>
  import("@/components/Modals/Labels/LabelMaterials.vue" /* webpackChunkName: "labelMaterials" */)
);
export const CustomLabelSizes = defineAsyncComponent(() =>
  import(
    "@/components/Modals/Labels/CustomLabelSizes.vue" /* webpackChunkName: "customLabelSizes" */
  )
);
export const GuideLines = defineAsyncComponent(() =>
  import("@/components/Modals/GuideLines.vue" /* webpackChunkName: "guideLines" */)
);
export const Help = defineAsyncComponent(() =>
  import("@/components/Modals/Help.vue" /* webpackChunkName: "help" */)
);
export const PrintPreview = defineAsyncComponent(() =>
  import("@/components/Modals/Printing/PrintPreview.vue" /* webpackChunkName: "printPreview" */)
);
export const PrintingCompleted = defineAsyncComponent(() =>
  import(
    "@/components/Modals/Printing/PrintingCompleted.vue" /* webpackChunkName: "printingCompleted" */
  )
);
export const PrintingHelp = defineAsyncComponent(() =>
  import("@/components/Modals/Printing/PrintingHelp.vue" /* webpackChunkName: "printingHelp" */)
);
export const TroubleShooting = defineAsyncComponent(() =>
  import(
    "@/components/Modals/Printing/TroubleShooting.vue" /* webpackChunkName: "troubleShooting" */
  )
);
export const SmallPage = defineAsyncComponent(() =>
  import("@/components/Modals/Printing/SmallPage.vue" /* webpackChunkName: "smallPage" */)
);
export const ShiftedVertical = defineAsyncComponent(() =>
  import(
    "@/components/Modals/Printing/ShiftedVertical.vue" /* webpackChunkName: "shiftedVertical" */
  )
);
export const Mismatched = defineAsyncComponent(() =>
  import("@/components/Modals/Printing/Mismatched.vue" /* webpackChunkName: "mismatched" */)
);
export const AlignmentWizard = defineAsyncComponent(() =>
  import(
    "@/components/Modals/Printing/AlignmentWizard.vue" /* webpackChunkName: "alignmentWizard" */
  )
);
export const Contact = defineAsyncComponent(() =>
  import("@/components/Modals/Printing/Contact.vue" /* webpackChunkName: "contact" */)
);
export const SaveLabel = defineAsyncComponent(() =>
  import("@/components/Modals/User/SaveLabel.vue" /* webpackChunkName: "saveLabel" */)
);
export const LoginModal = defineAsyncComponent(() =>
  import("@/components/Modals/User/LoginModal.vue" /* webpackChunkName: "loginModal" */)
);
export const ForgotPassword = defineAsyncComponent(() =>
  import("@/components/Modals/User/ForgotPassword.vue" /* webpackChunkName: "forgotPassword" */)
);
export const NameAndContinue = defineAsyncComponent(() =>
  import("@/components/Modals/User/NameAndContinue.vue" /* webpackChunkName: "nameAndContinue" */)
);
export const ConfirmBack = defineAsyncComponent(() =>
  import("@/components/Modals/Nav/ConfirmBack.vue" /* webpackChunkName: "confirmBack" */)
);
export const SaveConfirmation = defineAsyncComponent(() =>
  import("@/components/Modals/User/SaveConfirmation.vue" /* webpackChunkName: "saveConfirmation" */)
);
